import apiAuth from "../services/apis/apiAuth";
import dbConnection from "../services/utilities/dbConnection";

export const readToken = async() => {

    try {
        const token = localStorage.getItem('token_organizador');
        if( !token || token.length <= 10) { throw new Error() }
        
        const verificarToken = await apiAuth.verificarToken({ headers: { 'x-token': token }} );
        if( !verificarToken.ok ) { throw new Error() }
      
        const { newToken, usuario} = verificarToken.response.data;
        localStorage.setItem('token_organizador', newToken);
        dbConnection.defaults.headers.common['x-token'] = localStorage.getItem('token_organizador')
        
        return usuario;
    } catch (error) {
        return null;
    }

  
}